import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import ArticlesPage from "@/pages/ArticlesPage";
import ArticleDetailPage from "@/pages/ArticleDetailPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import AdminEditorPage from "@/pages/AdminEditorPage";
import RequireAdmin from "@/components/site/RequireAdmin";

function App() {
  return (
    <div className="App bg-paper text-navy min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/insights" element={<ArticlesPage />} />
          <Route path="/insights/:slug" element={<ArticleDetailPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <AdminDashboardPage />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/new"
            element={
              <RequireAdmin>
                <AdminEditorPage />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/edit/:id"
            element={
              <RequireAdmin>
                <AdminEditorPage />
              </RequireAdmin>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
